export default __webpack_public_path__ + "static/oryx-nl-39fda6c54f0347dbfd677d5566964ed3.jpg";